import { SurgeryForm } from "~/components/form/health-profile/SurgeryForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreateSurgery() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="surgeries">
            <SurgeryForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
